import * as React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import { RemoveScroll } from 'react-remove-scroll';

import { cn } from '@/new/lib/utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 6, onClick, ...props }, ref) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onClick?.(event);
  };

  const contentProps: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> = {
    align,
    sideOffset,
    onClick: handleClick,
    className: cn(
      'font-inter data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-98 data-[state=open]:zoom-in-98 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-full max-w-72 origin-[--radix-popover-content-transform-origin] rounded-md border bg-white p-4 py-3 text-sm text-gray-800 shadow-lg/4 outline-none',
      className,
    ),
    ...props,
  };

  return (
    <PopoverPrimitive.Portal>
      <RemoveScroll removeScrollBar={false} forwardProps>
        <PopoverPrimitive.Content ref={ref} {...contentProps} />
      </RemoveScroll>
    </PopoverPrimitive.Portal>
  );
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
